<template>
  <ion-header>
    <ion-toolbar>
      <div slot="start">
        <slot name="toolbar-start">
          <ion-buttons v-if="!hideCancel">
            <ion-button @click="cancel()">
              <ion-icon v-if="withBackIcon" slot="icon-only" :icon="chevronBack" />
              <span v-else>{{ cancelText }}</span>
            </ion-button>
          </ion-buttons>
        </slot>
      </div>

      <ion-title>{{ title }}</ion-title>

      <div slot="end">
        <slot name="toolbar-end">
          <ion-buttons v-if="!hideConfirm">
            <ion-button strong @click="confirm()">
              {{ confirmText }}
            </ion-button>
          </ion-buttons>
        </slot>
      </div>
    </ion-toolbar>

    <slot name="header-append" />
  </ion-header>

  <ion-content :class="paddingClass">
    <slot />
  </ion-content>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { chevronBack } from "ionicons/icons";
import {
  IonHeader,
  IonContent,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
} from "@ionic/vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  components: {
    IonHeader,
    IonContent,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonTitle,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    confirmLabel: {
      type: String,
      default: null,
    },
    cancelLabel: {
      type: String,
      default: null,
    },
    hideConfirm: {
      type: Boolean,
      default: false,
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    withBackIcon: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["cancel", "confirm"],

  setup(props, { emit }) {
    const { t } = useI18n();

    return {
      chevronBack,
      confirmText: computed(() => props.confirmLabel || t("message.vModal.confirm")),
      cancelText: computed(() => props.cancelLabel || t("message.vModal.cancel")),
      cancel: () => emit("cancel"),
      confirm: () => emit("confirm"),
      paddingClass: computed(() => (props.noPadding ? "" : "ion-padding")),
    };
  },
});
</script>
